import { z } from "zod";

export const ciSchema = z.object({
  name: z.string().min(1),
  url: z.string().default(""),
  tagline: z.string().default(""),
  usp: z.string().default(""),
  voice: z.string().default("selbstbewusst, klar, freundlich"),
  industry: z.string().default("saas"),
  colors: z.object({
    primary: z.string(),
    secondary: z.string(),
    accent: z.string(),
    bg: z.string(),
    fg: z.string(),
    muted: z.string().default("#94A3B8"),
  }),
  fonts: z.object({
    heading: z.string().default("Inter"),
    body: z.string().default("Inter"),
  }),
  /** Default-Render-Theme der Marke. Pro Reel via `theme` überschreibbar.
   *  Optional gehalten, damit bestehende CI-Objektliterale (z. B. in
   *  brandExtract) gültig bleiben; `undefined` wird in theme.ts als "dark"
   *  behandelt. */
  theme: z.enum(["dark", "light"]).optional(),
  logo: z.string().default("src/brand/logo.svg"),
  logoMode: z.enum(["auto", "light", "dark"]).default("auto"),
  /**
   * "wordmark" → logo includes the brand name (don't render brand text next to it).
   * "icon" → logo is just an emblem/symbol (render brand text alongside).
   * "auto" → infer from aspect ratio (handled in BrandLogo).
   */
  logoType: z.enum(["wordmark", "icon", "auto"]).default("auto"),
});

export type CI = z.infer<typeof ciSchema>;
